import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const AMENITY_TYPES = [
  { value: "trailhead", label: "Trailhead", color: "#10B981" },
  { value: "parking", label: "Parking", color: "#EAB308" },
  { value: "bathroom", label: "Restroom", color: "#8B5CF6" },
  { value: "water_station", label: "Water", color: "#06B6D4" },
];

export function TrailheadPinDialog({ pin, onClose, onSave, onDelete, saving }) {
  const [f, setF] = useState(null);
  useEffect(() => { setF(pin ? { type: "trailhead", name: "", notes: "", is_primary: false, ...pin } : null); }, [pin]);
  if (!f) return null;
  const set = (k, v) => setF((s) => ({ ...s, [k]: v }));
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="amenity-pin-dialog">
        <DialogHeader><DialogTitle>{f.id ? "Edit pin" : "New pin"}</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div><Label>Type</Label>
            <Select value={f.type} onValueChange={(v) => set("type", v)}>
              <SelectTrigger data-testid="amenity-type-select"><SelectValue /></SelectTrigger>
              <SelectContent>{AMENITY_TYPES.map((t) => <SelectItem key={t.value} value={t.value} data-testid={`amenity-type-${t.value}`}>{t.label}</SelectItem>)}</SelectContent>
            </Select></div>
          <div><Label>Name</Label><Input value={f.name} onChange={(e) => set("name", e.target.value)} placeholder="e.g. Bristol Trailhead" data-testid="amenity-name-input" /></div>
          <div><Label>Notes (optional)</Label><Textarea rows={2} value={f.notes} onChange={(e) => set("notes", e.target.value)} data-testid="amenity-notes-input" /></div>
          <p className="text-xs text-muted-foreground" data-testid="amenity-coords">Location: {f.lat.toFixed(5)}, {f.lng.toFixed(5)}. Drag the pin on the map to move it.</p>
          {f.type === "trailhead" && (
            <label className="flex items-center justify-between gap-3 rounded-lg border border-border p-3">
              <span><span className="block text-sm font-semibold">Primary trailhead</span>
                <span className="block text-xs text-muted-foreground">Riders are sent here first. Only one per path.</span></span>
              <Switch checked={!!f.is_primary} onCheckedChange={(v) => set("is_primary", v)} data-testid="amenity-primary-switch" className="data-[state=unchecked]:bg-slate-500" />
            </label>
          )}
        </div>
        <DialogFooter className="gap-2 sm:justify-between">
          {f.id ? <Button variant="destructive" onClick={() => onDelete(f)} disabled={saving} data-testid="amenity-delete-btn">Delete</Button> : <span />}
          <Button onClick={() => onSave(f)} disabled={saving || !f.name.trim()} data-testid="amenity-save-btn">{saving ? "Saving…" : "Save pin"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
